import { useRouter } from "next/compat/router";
import * as qs from "qs";
import { useMemo } from "react";

export const useQueryString = (): qs.ParsedQs => {
  const { asPath = "" } = useRouter() || {};

  const query = useMemo(() => {
    if (!asPath) {
      return {};
    }

    return qs.parse(asPath.split(/\?/)[1], { parseArrays: false });
  }, [asPath]);

  return query;
};

export const useRouterQueryParameter = (queryParameterName: string): string => {
  const { query = {} } = useRouter() || {};

  const queryParameterValue = query[queryParameterName];
  if (Array.isArray(queryParameterValue)) {
    throw new Error(
      `The query parameter "${queryParameterName}" param should be unique in the query string: it could not be used multiple time as an array of query params.`,
    );
  }

  if (queryParameterValue === undefined) {
    return "";
  }

  return queryParameterValue;
};

export const useRouterQueryStringParameterQuery = (
  queryStringParameterName: string,
):
  | { isReady: false; value: undefined }
  | { isReady: true; value: string | undefined } => {
  const { isReady, query = {} } = useRouter() || {};

  if (!isReady) {
    return { isReady: false, value: undefined };
  }

  const queryStringParameterValue = query[queryStringParameterName];
  if (Array.isArray(queryStringParameterValue)) {
    throw new Error(
      `The query parameter "${queryStringParameterName}" param should be unique in the query string: it could not be used multiple time as an array of query params.`,
    );
  }

  return { isReady: true, value: queryStringParameterValue };
};
